"use client"

import { type AuthMeResponse } from "@/features/auth/model/auth-types"
import { useAuthContextStore } from "@/features/auth/services/auth-context-store"

type ResolvedWorkspaceContext = {
  workspaceId?: string | null
  workspaceSlug?: string | null
}

/** Authorization refreshes never own navigation context. */
export function applyAuthoritativeAuthContext(authMe: AuthMeResponse | null) {
  useAuthContextStore.getState().setAuthMe(authMe)
}

/** Apply only a workspace already validated by the authoritative tenant resolver. */
export function applyResolvedTenantContext(context: ResolvedWorkspaceContext) {
  useAuthContextStore.getState().setActiveWorkspace(
    context.workspaceId ?? null,
    context.workspaceSlug ?? null,
  )
}

export function clearAuthoritativeAuthContext() {
  const { setAuthMe, setActiveWorkspace } = useAuthContextStore.getState()
  setAuthMe(null)
  setActiveWorkspace(null, null)
}
